module.exports = __webpack_public_path__ + "static/media/ProblemSolving.9b116ce2.jpg";